import styled from 'styled-components';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { formatNumberWithoutFractions } from '~/utils/helpers';

interface SliderProps {
  control: any
  question: any
  setValue: any
  activeIndex: string | number
  getValues: any
}

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SliderC = styled.input.attrs({
  type: 'range'
}) <{ rating?: number }>`
  flex: 1;
  margin: 0 10px;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(to right, ${props => props.theme.firstColor} 0%, ${props => props.theme.firstColor} ${(props) => props.rating}%, #EDEFF1 ${(props) => props.rating}%, #EDEFF1 100%);
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${props => props.theme.firstColor};
    cursor: pointer;
  }

  &::-webkit-slider-runnable-track {
   
  }

  &:hover {
    opacity: 1;
  }

  &:active::-webkit-slider-thumb {
    background-color: ${props => props.theme.secondColor};
  }
`;

export const MinMaxLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
`;

export const MinValueLabel = styled(MinMaxLabel)`
  margin-right: 10px;
`;

export const MaxValueLabel = styled(MinMaxLabel)`
  margin-left: 10px;
`;

const Slider: React.FC<SliderProps> = (props) => {
  const { control, setValue, question, activeIndex, getValues } = props
  const { t } = useTranslation()
  const [rating, setRating] = useState(0);

  useEffect(() => {
    const value = getValues(`questions[${activeIndex}].answers[0].value`)
    if (value) {
      setRating(value)
    }
  }, [props])

  const handleChange = (event) => {
    setRating(event.target.value);
    setValue(`questions[${activeIndex}].answers[0].value`, event.target.value)
  };

  return <FormFields.External
    control={control}
    rules={{
      required: question?.required ? t('Please move slider') : null
    }}
    label={question?.question}
    placeholder={question?.placeholder}
    name={`questions[${activeIndex}].answers[0].value`}
  >
    <>
      <Form.Field label={t('Rating: {{rating}} {{watchUnit}}',
        { rating: formatNumberWithoutFractions(rating), watchUnit: question?.unitLabel || '' })} />
      <SliderWrapper>
        <MinValueLabel>{`${formatNumberWithoutFractions(question?.minValue)} ${question?.unitLabel || ''}`}</MinValueLabel>
        <SliderC
          step={question?.interval}
          rating={((rating - question?.minValue) / (question?.maxValue - question?.minValue)) * 100}
          min={question?.minValue}
          max={question?.maxValue}
          value={rating}
          onChange={(e) => handleChange(e)}
        />
        <MaxValueLabel>{`${formatNumberWithoutFractions(question?.maxValue)} ${question?.unitLabel || ''}`}</MaxValueLabel>
      </SliderWrapper>
    </>
  </FormFields.External>
}
export default Slider